class CartOverviewItem extends Component {
	constructor(el) {
		super(el);
		this.isDelivery = this.$el.dataset.delivery !== undefined;
		this.isPayment = this.$el.dataset.payment !== undefined;
		this.title = this.$find('[data-title]');
		this.image = this.$find('[data-image]');
		this.price = this.$find('[data-price]');
		this.addEventListeners();
	}

	updateData({title, image, priceVatFormatted}) {
		this.title.innerHTML = title;
		this.price.innerHTML = priceVatFormatted;
		if (this.image) {
			this.image.querySelector('img').src = image;
			this.image.querySelector('source').srcset = image;
		}
	}

	addEventListeners() {
		this.isDelivery && EventBus.getInstance().addEventListener('cartDeliveryChanged', e => this.updateData(e.detail));
		this.isPayment && EventBus.getInstance().addEventListener('cartPaymentChanged', e => this.updateData(e.detail));
	}
}